import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { ASSET_URL } from '../../env/Configurations';
import './Custom-Document-Viewer.scss';
import { S3_TYPE } from '../../constants/CommonConst';

const CustomDocumentViewer = ({ document, title }) => {
  const [fileUrl, setFileUrl] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!document) return;
    const url = document?.type === S3_TYPE ? `${ASSET_URL}${document?.url}` : document?.url;
    setFileUrl(url);
  }, [document]);
  const handleOpen = () => {
    if (document?.type !== S3_TYPE) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } else {
      setOpen(true);
    }
  };

  return (
    <div className='custom-document-viewer'>
      <div className='document-card' onClick={handleOpen}>
        <img
          className='image-card'
          src={
            document?.type !== S3_TYPE
              ? '/assets/img/link_black_24dp.svg'
              : '/assets/img/description_black_36dp.svg'
          }
          alt='open document'
        />
        <p className='doc-title'>{title}</p>
      </div>
      {document?.type === S3_TYPE && (
        <Dialog
          className='document-viewer'
          open={open}
          onClose={() => setOpen(false)}
          maxWidth='lg'
          fullWidth
        >
          <DialogContent className='document-viewer-content'>
            <Cancel className='document-viewer-close' onClick={() => setOpen(false)} />
            {fileUrl ? (
              <iframe className='pdf-iframe' src={fileUrl} title={title || 'Document Preview'} />
            ) : (
              <p className='doc-error'>No document URL available.</p>
            )}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CustomDocumentViewer;
